import Loadable from '@loadable/component';

const LazyLoad = Loadable(() => import(/* webpackPreload: true */ '.'));
export default LazyLoad;
